import React, { useState, useRef, useEffect, Dispatch, SetStateAction } from 'react'
import styled from 'styled-components'

import Search from 'components/Search'

type Props = {
  query?: string;
  className?: string;
  onSearch?: () => void;
  showSpinner?: boolean;
  setShowSpinner?: (val: boolean) => boolean;
}

const PagedSearch = ({ query = '', onSearch = () => '', className = '', showSpinner = false, setShowSpinner = () => false }: Props) => {
  const [inputValue, setInputValue] = useState(query)

  const searchInputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    searchInputRef.current?.focus()
  }, [searchInputRef])

  return (
    <S.Container className={className}>
      <S.SearchContainer>
        <S.Search
          ref={searchInputRef}
          ariaLabel="paged search"
          placeholder="Search"
          value={inputValue}
          showClearIcon={false}
          onClickClearIcon={() => {
            setInputValue('')
            searchInputRef.current?.focus()
            setShowSpinner(false)
          }}
          onChange={setInputValue}
          onSearch={onSearch}
          showSpinner={showSpinner}
        />
      </S.SearchContainer>
    </S.Container>
  )
}

export default PagedSearch

const S = {
  Container: styled.div`
    white-space: nowrap;
  `,
  SearchContainer: styled.div`
    display: flex;
    flex-wrap: nowrap;
  `,
  Search: styled(Search)<{ ariaLabel: string, placeholder: string, value: string, showClearIcon: boolean,
    onClickClearIcon: () => void, onChange: Dispatch<SetStateAction<string>>, onSearch: () => void }>`
    display: inline-block;
    width: 265px;
  `,
  Label: styled.div`
    padding: 10px 15px 0 0;
    font-weight: 600;
    text-align: right;
    width: 100px;
    float: left;
  `
}
